module.exports = __webpack_public_path__ + "static/media/Ventilator.48b98884.png";